/**
 * Supported button styles.
 * @type {Object<String>}
 */
export const STYLES = {
    DEFAULT: 'default',
    LEAN_TOGGLED: 'lean_toggled',
    LEAN_WITH_DISCLAIMER: 'lean_with_disclaimer',
};
